// /constants/getLabel.js
import i18next from "i18next";

export const getLabel = (key) => {
  return i18next.t(`statementoffact:labels.${key}`, key);
};
